import Add from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import NewEntrataClientDialog from './NewEntrataClientDialog'

export default function NewEntrataClientButton() {
  const overlay = useOverlay()

  return (
    <>
      <Button
        onClick={overlay.open}
        startIcon={<Add />}
        variant="text"
        sx={{ mb: 1 }}
      >
        New Client
      </Button>
      <NewEntrataClientDialog overlay={overlay} />
    </>
  )
}
